import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IContactMappedItem } from '@app/logic/contacts/interfaces/i.contact.mapped';
import { ContactsSearchService } from '@app/core/services/search/contacts-search.service';
import { ContactsLogicService } from '@app/logic/contacts';
import { ContactsInputFindDialogDirective } from './contacts-input-find-dialog.directive';

interface IData {
    mappedItem: IContactMappedItem;
    searchService: ContactsSearchService;
    extraSearchParams: { [key: string]: any };
    dialogHeading: string;
    contentHeading: string;
    placeholder: string;
}

@Component({
    selector: 'cb-contacts-input-find-dialog-cards',
    templateUrl: '../../input-find-dialog-cards/input-find-dialog-cards.component.html',
    styleUrls: ['../../input-find-dialog-cards/input-find-dialog-cards.component.scss'],
    providers: [ContactsLogicService],
    standalone: false
})
export class ContactsInputFindDialogCardsComponent extends ContactsInputFindDialogDirective {
    constructor(
        public readonly dialogRef: MatDialogRef<ContactsInputFindDialogDirective>,
        @Inject(MAT_DIALOG_DATA) public readonly data: IData,
        public logicService: ContactsLogicService,
        public cdRef: ChangeDetectorRef
    ) {
        super(
            dialogRef,
            data,
            logicService,
            cdRef,
        );
    }
}

